import { StarBoxMultipleOutlineIcon } from './StarBoxMultipleOutlineIcon';

/**
 * author: Yaroslav Bandura
 * id 2B9ACC0A-EA3D-478D-935E-EAFA8F8580CF
 * name star-box-multiple-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-box-multiple-outline.svg
 * tags
 */
export const FavoriteBoxMultipleOutlineIcon = StarBoxMultipleOutlineIcon;
export default FavoriteBoxMultipleOutlineIcon